/**
 * Quién usa mensajes en cnc-client: el usuario que está en el grupo «Mensajes» de la API
 * (ROLE_MENSAJES; ver GrupoMensajes). Piloto: el resto no ve ni el sobre, ni la acción de los
 * listados, ni la ruta, y no se le sondea nada. En cnc-admin hace falta además ROLE_EMPLEADO.
 */
export const ROL_MENSAJES = 'ROLE_MENSAJES';

export function puedeUsarMensajes(sesion: {isLogged(): boolean; hasRole(rol: string): boolean}): boolean {
    return sesion.isLogged() && sesion.hasRole(ROL_MENSAJES);
}
